<template>
  <div class="notify-phones-card">
    <div class="section-header" @click="toggleSection">
      <i
        :class="['mdi', isExpanded ? 'mdi-chevron-down' : 'mdi-chevron-right']"
      ></i>
      <span>Номери для сповіщення</span>
      <div class="header-actions" @click.stop>
        <span class="phone-count">{{ notifyPhones.length }}</span>
      </div>
    </div>

    <div v-if="isExpanded" class="phone-list">
      <div
        v-for="(phone, index) in notifyPhones"
        :key="phone.number"
        class="phone-item"
      >
        <div class="phone-icon bg-soft-success">
          <i class="mdi mdi-bell"></i>
        </div>

        <div class="phone-content">
          <div class="phone-number">+{{ formatPhoneNumber(phone.number) }}</div>
          <div class="phone-company">
            {{ phone.companyName || "Компанія не додана" }}
          </div>
        </div>

        <div class="phone-actions">
          <button
            class="action-btn action-btn-remove"
            @click.stop="removeFromNotify(phone, index)"
            title="Видалити зі списку сповіщення"
          >
            <i class="mdi mdi-close"></i>
          </button>
        </div>
      </div>

      <div v-if="notifyPhones.length === 0" class="empty-state">
        <i class="mdi mdi-bell-off"></i>
        <p>Немає номерів для сповіщення</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotifyPhonesList",
  props: {
    clients: {
      type: Array,
      default: () => [],
    },
    ticketId: {
      type: [String, Number],
      default: null,
    },
    savedNotifyPhones: {
      type: Array,
      default: null,
    },
  },
  emits: ["update-notify-phones"],
  data() {
    return {
      isExpanded: true,
      notifyPhones: [],
      initialized: false,
    };
  },
  watch: {
    clients: {
      handler(newClients) {
        if (!this.initialized && newClients && newClients.length > 0) {
          // При першому завантаженні - всі клієнти додаються в список сповіщення
          if (this.savedNotifyPhones !== null) {
            // Якщо є збережені номери - використовуємо їх
            this.notifyPhones = [...this.savedNotifyPhones];
          } else {
            // Інакше копіюємо всіх клієнтів
            this.notifyPhones = newClients.map(client => ({
              number: client.number,
              companyId: client.companyId,
              companyName: client.companyName,
            }));
          }
          this.initialized = true;
          this.emitUpdate();
        } else if (this.initialized) {
          // Якщо додано нового клієнта - автоматично додаємо в список сповіщення
          const currentNumbers = this.notifyPhones.map(p => p.number);
          newClients.forEach(client => {
            if (!currentNumbers.includes(client.number)) {
              this.notifyPhones.push({
                number: client.number,
                companyId: client.companyId,
                companyName: client.companyName,
              });
            }
          });
          this.emitUpdate();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    toggleSection() {
      this.isExpanded = !this.isExpanded;
    },
    formatPhoneNumber(number) {
      const numStr = String(number);
      if (numStr.length >= 12) {
        return `${numStr.slice(0, 3)} ${numStr.slice(3, 5)} ${numStr.slice(
          5,
          8
        )} ${numStr.slice(8, 10)} ${numStr.slice(10)}`;
      }
      return numStr;
    },
    removeFromNotify(phone, index) {
      this.notifyPhones.splice(index, 1);
      this.emitUpdate();
      this.$toast.success("Номер видалено зі списку сповіщення");
    },
    emitUpdate() {
      this.$emit("update-notify-phones", [...this.notifyPhones]);
    },
    // Публічний метод для отримання списку номерів
    getNotifyPhones() {
      return this.notifyPhones.map(p => p.number);
    },
  },
};
</script>

<style scoped>
.notify-phones-card {
  background: #fff;
  border-radius: 8px;
  margin-bottom: 8px;
  overflow: hidden;
}

.section-header {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  cursor: pointer;
  user-select: none;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  gap: 8px;
}

.section-header:hover {
  background: #e9ecef;
}

.section-header i {
  color: #6c757d;
  font-size: 18px;
}

.section-header span {
  font-weight: 500;
  font-size: 13px;
  color: #495057;
  flex: 1;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.phone-count {
  background: #28a745;
  color: white;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 10px;
  min-width: 20px;
  text-align: center;
}

.phone-list {
  padding: 8px;
}

.phone-item {
  display: flex;
  align-items: center;
  padding: 8px;
  border-radius: 6px;
  margin-bottom: 4px;
  background: #f8f9fa;
  gap: 10px;
  transition: background-color 0.15s;
}

.phone-item:hover {
  background: #e9ecef;
}

.phone-item:last-child {
  margin-bottom: 0;
}

.phone-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.phone-icon i {
  font-size: 14px;
}

.bg-soft-success {
  background-color: rgba(40, 167, 69, 0.15);
  color: #28a745;
}

.phone-content {
  flex: 1;
  min-width: 0;
}

.phone-number {
  font-size: 13px;
  font-weight: 500;
  color: #212529;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.phone-company {
  font-size: 11px;
  color: #6c757d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.phone-actions {
  display: flex;
  align-items: center;
}

.action-btn {
  width: 26px;
  height: 26px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}

.action-btn-remove {
  background: transparent;
  color: #6c757d;
}

.action-btn-remove:hover {
  background: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}

.action-btn i {
  font-size: 16px;
}

.empty-state {
  text-align: center;
  padding: 20px;
  color: #6c757d;
}

.empty-state i {
  font-size: 32px;
  margin-bottom: 8px;
  opacity: 0.5;
}

.empty-state p {
  margin: 0;
  font-size: 12px;
}
</style>
